import { i18n } from '@/setup/i18nSetup'

const countries = {
  DK: {
    regex: new RegExp(/^\d{4}$/),
    number: 4
  },
  SE: {
    regex: new RegExp(/^\d([ ]*\d[ ]*){4}$/),
    number: 5
  }
}

const postalCode = {
  getMessage: (value, countryCode) => {
    const number = countries[countryCode].number
    return i18n.t('W2P_VALIDATION_DYNAMIC_POSTALCODE_FORMAT', {
      number: number
    })
  },
  validate: (value, countryCode) => {
    if (countryCode === undefined) {
      throw Error('No country given')
    }

    if (countries[countryCode] === undefined) {
      return true
    }

    return countries[countryCode].regex.test(value)
  }
}

export default postalCode
